import { cssTheme } from '@uds/theme-utils';
import { css, cx } from 'linaria';

import { HeroDesignOptions } from './DomainSearchHero';

const paddingTop = css`
  &&& {
    padding-top: ${cssTheme.gu4};

    ${cssTheme.breakpoints.md} {
      padding-top: ${cssTheme.gu5};
    }

    ${cssTheme.breakpoints.lg} {
      padding-top: ${cssTheme.gu6};
    }
  }
`;

const paddingBottom = css`
  &&& {
    padding-bottom: ${cssTheme.gu4};

    ${cssTheme.breakpoints.md} {
      padding-bottom: ${cssTheme.gu5};
    }

    ${cssTheme.breakpoints.lg} {
      padding-bottom: ${cssTheme.gu6};
    }
  }
`;

const defaultPadding = css`
  padding-top: ${cssTheme.gu1};
  padding-bottom: ${cssTheme.gu1};
`;

export const getClassNames = ({ design }: { design: HeroDesignOptions }) => ({
  root: cx(
    defaultPadding,
    design?.collapsePadding?.top !== true && paddingTop,
    design?.collapsePadding?.bottom !== true && paddingBottom,
  ),
});
